import axios from 'axios';

export default class QuestionQuery {
  static getUserInfo() {
    return axios.get('/api/user/basic_info').then(res => {
      return res.data;
    }, err => {
      return Promise.reject(err);
    });
  }

  static jianWeiUserCheck(authorization) {
    return axios.get(`/api/user/check/authorize?authorization=${encodeURIComponent(authorization)}`).then(res => {
      return res;
    }, err => {
      return Promise.reject(err);
    });
  }

  static textPrecision(obj) {
    return axios.post('/api/search/research_report_title_and_text/precision', obj).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static textFuzzy(obj) {
    return axios.post('/api/search/research_report_title_and_text/fuzzy', obj).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static chartPrecision(obj) {
    return axios.post('/api/search/research_report_figure/precision', obj).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static chartFuzzy(obj) {
    return axios.post('/api/search/research_report_figure/fuzzy', obj).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static batchDownload(id) {
    return axios.post('/api/search/batch_download', { id }, {
      responseType: 'blob'
    }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }
  static serviceStatus() {
    return axios.get('/api/info/status').then(res => {
      return res.data;
    },
    err => {
      return Promise.reject(err.response);
    });
  }
  static collectPdf(id, highlight, summaries, folder) {
    return axios.put('/api/user/research_report/collect_pdf', { 
      id, 
      highlight, 
      summaries, 
      folder 
    }).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static uncollectPdf(id) {
    return axios.delete('/api/user/research_report/uncollect_pdf', { data: { id } }).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static collectFigure(id, highlight, folder) {
    return axios.put('/api/user/research_report/collect_figure', { id, highlight, folder }).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static uncollectFigure(id) {
    return axios.delete('/api/user/research_report/uncollect_figure', { data: { id } }).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static getDisplay() {
    return axios.get('/api/user/research_report/display').then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static getDisplayCollectionList(folder, pageNum, pageSize, sortOrder) {
    return axios.get(`/api/user/research_report/display?folder=${folder}&pageNum=${pageNum}&pageSize=${pageSize}&sortOrder=${sortOrder}`).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static mail(mail) {
    return axios.put('/api/user/mail', { mail }).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err.response);
      }
    );
  }

  static changeUsername(username) {
    return axios.put('/api/user/username', { username }).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err.response);
      }
    );
  }

  static changePhone(phone, smsCode) {
    return axios.put('/api/user/phone', { phone, sms_code: smsCode }).then(
      res => {
        return res.data || {};
      },
      err => {
        return Promise.reject(err.response);
      }
    );
  }

  static hotStock() {
    return axios.get('/api/info/hot_stock').then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static hotSubject() {
    return axios.get('/api/info/hot_subject').then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static gatChart() {
    return axios.get('/api/info/chart').then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static deleteCollectedHistory(id) {
    return axios.delete('/api/user/collected_history', { data: { id } }).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static historySearchRename(id, alias) {
    return axios.put('/api/user/history', { id, alias }).then(
      res => {
        return res.data || {};
      }, 
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getCollectedHistory() {
    return axios.get('/api/user/collected_history').then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
  }

  static getHistory(pageNum, pageSize) {
    return axios.get(`/api/user/history?pageNum=${pageNum}&pageSize=${pageSize}`).then(
      res => {
        return res.data || {};
      },
      () => { 
        return false;
      }
    );
    // return axios.get('/mock/history.json').then(
    //   res => {
    //     return res.data || {};
    //   },
    //   () => { 
    //     return false;
    //   }
    // );
  }

  static addFolder(name) {
    return axios.post('/api/user/research_report/folder', { name }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }
  
  static deleteFolder(folder) {
    return axios.delete('/api/user/research_report/folder', { data: { folder } }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static changeFolderName(originalFolder, alias) {
    return axios.put('/api/user/research_report/folder', { originalFolder, alias }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static changePasswordBySms(sms, newPassword) {
    return axios.put('/api/user/password_by_sms', { sms, new_password: newPassword }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static changePasswordByOrigin(oldPassword, newPassword) {
    return axios.put('/api/user/password_by_origin', { old_password: oldPassword, new_password: newPassword }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static checkSms(sms) {
    return axios.post('/api/user/check/sms', { sms }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static checkPassword(password) {
    return axios.post('/api/user/check/password', { password }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static postSms(phoneNumber) {
    return axios.post('/api/user/sms', { phoneNumber }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static signup(phoneNumber, password, verifyCode) {
    return axios.post('/api/user/signup', { phoneNumber, password, verifyCode }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static login(inputString, password) {
    return axios.post('/api/user/login', { inputString, password }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static smsLogin(phone, smsCode) {
    return axios.post('/api/user/sms_login', { phone, sms_code: smsCode }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err.response);
      }
    );
  }

  static getResearchReportNumber() {
    return axios.get('/api/info/chart').then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  static getOrderList() {
    return axios.get('/api/pay/display_order').then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  // static getHotStocks() {
  //   return axios.get('/mock/hot-stocks.json').then(
  //     res => {
  //       return Promise.resolve(res.data);
  //     },
  //     (err) => {
  //       return Promise.reject(err);
  //     }
  //   );
  // }

  static clearHistory() {
    return axios.delete('/api/user/history').then(
      res => {
        return Promise.resolve(res);
      },
      err => { 
        return Promise.reject(err);
      }
    );
  }
  
  static getHotSpecialTopic() {
    return axios.get('/mock/hot-special-topic.json').then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }
  
  static getPayProduct() {
    return axios.get('/api/pay/product').then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }
  
  static postWechatOrder(productId) {
    return axios.post('/api/pay/wechat/order', {
      'productID': productId
    }).then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  static getPdfData(link) {
    return axios.get(link, {
      responseType: 'arraybuffer'
    }).then(
      res => {
        return Promise.resolve(res.data);
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static getPdfDownload(query, filename, institution, date) {
    return axios
      .get(query, {
        responseType: 'blob'
      })
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const fileName = filename;
          // 返回的header Content-Disposition:attachment; filename=elmeast-report-2018-2.pdf
          // const head = response.headers['content-disposition'];
          const fname = `${fileName}-${institution}-${date}.pdf`;
          // if (head) {
          //   try {
          //     fname = head.split(';')[1].split('=')[1];
          //   } catch (err) {
          //     // console.log('can not get pdf name');
          //   }
          // }
          link.href = url;
          link.setAttribute('download', fname);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          return Promise.resolve(true);
        },
        err => {
          return Promise.reject(err.response);
        }
        // error => {
        //   if (error.response.status >= 500) {
        //     return Promise.resolve('ServerError');
        //   } else if (error.response.status === 404) {
        //     return Promisr.resolve('ResourcesError');
        //   } else if (error.response.status === 400) {
        //     return Promise.resolve('NO_TIMES');
        //   } 
        //   return Promise.resolve(false);  
        // }
      );
  }

  static getRechargeResult(tradeNo) {
    return axios.post('api/pay/wechat/query', {
      trade_no: tradeNo
    }).then(
      res => {
        return Promise.resolve(res);
      },
      err => {
        return Promise.reject(err);
      }
    );
  }

  static wechatAuthorize(code) {
    return axios.post('/api/user/check/wechat_authorize', { code }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err);
      }
    );
  }

  static bindWechat(code) {
    return axios.put('/api/user/bind_wechat', { code }).then(
      res => {
        return res.data || {};
      }, err => {
        return Promise.reject(err);
      }
    );
  }

  static feedbackPropose(title, content, mobile) {
    return axios.post('/api/feedback/propose', { title, content, mobile }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err);
      }
    );
  }

  static getFeedbackList() {
    return axios.get('/api/feedback/list').then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  static getFeedbackReply(id) {
    return axios.get(`/api/feedback/reply/${id}`).then(
      res => {
        return Promise.resolve(res.data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  static postFeedbackReply(id, content) {
    return axios.post('/api/feedback/reply', { id, content }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err);
      }
    );
  }

  static dynamicMatch(input) {
    return axios.post('/api/search/dynamic_match', { input }).then(
      res => {
        return res.data;
      }, err => {
        return Promise.reject(err);
      }
    );
  }
}
